<!-- QuickPlane Base -->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
// 所有共用scss於此引入
@import '@/styles/element-variables.scss';
@import '@/styles/z-index.scss';
@import '@/styles/global.scss';
</style>
